<template>
  <!-- This example requires Tailwind CSS v2.0+ -->
  <div
    class="relative bg-white overflow-hidden"
    :class="heroClass"
    :style="heroStyle"
  >
    <div class="mx-auto">
      <div
        class="hero-content relative z-10 pb-8 bg-white sm:pb-16 md:pb-20 lg:max-w-2xl lg:w-full lg:pb-28 xl:pb-32"
        :style="contentStyle"
      >
        <div>
          <!-- <div class="relative pt-6 px-4 sm:px-6 lg:px-8"></div> -->

          <main
            class="mt-10 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28"
          >
            <div class="sm:text-center lg:text-left">
              <div v-if="showLanguageSwitcher">
                <button @click="switchEnglish">
                  <div style="font-size: 50px">
                    <flag iso="us" />
                  </div>
                </button>
                <button class="pl-4" @click="switchGerman">
                  <div style="font-size: 50px">
                    <flag iso="de" />
                  </div>
                </button>
              </div>
              <p v-if="heroEyebrow" class="hero-eyebrow">
                {{ heroEyebrow }}
              </p>
              <h1
                class="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl mb-3 pt-7"
              >
                <span
                  class="block xl:inline bullet"
                  v-if="$i18n.locale === 'de'"
                  v-html="personNameDe"
                ></span>
                <span
                  class="block xl:inline bullet"
                  v-if="$i18n.locale === 'en'"
                  v-html="personNameEn"
                ></span>
              </h1>
              <slot name="after-headline"></slot>
              <div class="h-5"></div>
              <h2
                v-if="showAboutHeadline"
                class="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-3xl md:text-3xl"
              >
                <span class="block xl:inline" v-if="aboutHeadline">{{
                  aboutHeadline
                }}</span>
                <span
                  class="block xl:inline"
                  v-else-if="$i18n.locale === 'de'"
                  >Über mich</span
                >
                <span class="block xl:inline" v-else>About me</span>
              </h2>
              <p
                class="mt-3 text-base sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0"
                v-html="aboutText || $t('message')"
              ></p>
              <slot name="after-text"></slot>
              <div
                v-if="desktopSpacerHeight"
                class="hero-desktop-spacer"
                :style="{ height: desktopSpacerHeight }"
              ></div>
            </div>
          </main>
        </div>
      </div>
    </div>
    <div class="hero-image lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
      <img
        class="hero-image__img h-56 w-full object-cover sm:h-96 md:h-96 lg:w-full lg:h-full"
        :src="imageSrc"
        :alt="imageAlt"
        :style="imageStyle"
      />
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { defineComponent } from "vue";

export default defineComponent({
  name: "HelloI18n",
  props: {
    imageSrc: {
      type: String,
      default: require("../assets/3K6A7596_1_k01.jpg"),
    },
    imageAlt: {
      type: String,
      default: "",
    },
    heroClass: {
      type: String,
      default: "",
    },
    personNameDe: {
      type: String,
      default: "KR. Dr. Andreas<br />J. Ludwig",
    },
    personNameEn: {
      type: String,
      default: "Dr. Andreas<br />J. Ludwig",
    },
    heroEyebrow: {
      type: String,
      default: "",
    },
    aboutHeadline: {
      type: String,
      default: "",
    },
    aboutText: {
      type: String,
      default: "",
    },
    showLanguageSwitcher: {
      type: Boolean,
      default: true,
    },
    showAboutHeadline: {
      type: Boolean,
      default: true,
    },
    heroMinHeight: {
      type: String,
      default: "",
    },
    contentMinHeight: {
      type: String,
      default: "",
    },
    imageObjectFit: {
      type: String,
      default: "",
    },
    imageObjectPosition: {
      type: String,
      default: "",
    },
    imageScale: {
      type: String,
      default: "",
    },
    desktopSpacerHeight: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showMenu: false,
      langs: ["en", "de"],
    };
  },
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });

    return { t };
  },
  computed: {
    heroStyle() {
      return this.heroMinHeight ? { minHeight: this.heroMinHeight } : {};
    },
    contentStyle() {
      return this.contentMinHeight ? { minHeight: this.contentMinHeight } : {};
    },
    imageStyle() {
      return {
        ...(this.imageObjectFit ? { objectFit: this.imageObjectFit } : {}),
        ...(this.imageObjectPosition
          ? { objectPosition: this.imageObjectPosition }
          : {}),
        ...(this.imageScale
          ? {
              transform: `scale(${this.imageScale})`,
              transformOrigin: this.imageObjectPosition || "center center",
            }
          : {}),
      };
    },
  },
  methods: {
    switchEnglish() {
      this.$i18n.locale = "en";
    },
    switchGerman() {
      this.$i18n.locale = "de";
    },
  },
});
</script>

<style scoped>
.hero-eyebrow {
  color: #13a1c7;
  font-family: "Poppins", sans-serif;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  margin-bottom: 0;
  text-transform: uppercase;
}

.rasha-hero .hero-eyebrow {
  font-size: 1rem;
  font-weight: 800;
  line-height: 1.35;
}

.rasha-hero h1 {
  font-size: 2rem;
  line-height: 1.1;
}

.hero-desktop-spacer {
  display: none;
}

.hero-image__img {
  height: 28rem;
}

@media (min-width: 640px) {
  .hero-image__img {
    height: 36rem;
  }

  .rasha-hero h1 {
    font-size: 2.75rem;
  }
}

@media (min-width: 768px) {
  .rasha-hero h1 {
    font-size: 3rem;
  }
}

@media (min-width: 1024px) {
  .hero-image__img {
    height: 100%;
  }

  .hero-desktop-spacer {
    display: block;
  }

  .rasha-hero {
    min-height: 980px;
  }

  .rasha-hero .hero-eyebrow {
    font-size: 1.1rem;
  }

  .rasha-hero h1 {
    font-size: 3.25rem;
  }

  .rasha-hero .hero-content {
    min-height: 980px;
  }

  .rasha-hero .hero-image {
    min-height: 980px;
  }
}
</style>
